"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.58 10.289h6.494V3.75h3.524v6.539h6.822l-8.431 9.961z"
}), 'LongArrowDown');
//# sourceMappingURL=index.js.map